import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Label primitive. Emits `data-ui-label`; required marker is `data-required`. */
export function Label(props) {
    const { required, children, ...rest } = props;
    return (_jsxs("label", { "data-ui-label": "", ...rest, children: [children, required === true ? (_jsx("span", { "aria-hidden": "true", "data-required": "true", children: ' *' })) : null] }));
}
//# sourceMappingURL=Label.js.map